import { render, staticRenderFns } from "./EditNews.vue?vue&type=template&id=28cd68fc&scoped=true&"
import script from "./EditNews.vue?vue&type=script&lang=js&"
export * from "./EditNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd68fc",
  null
  
)

export default component.exports